import { inject, Injectable } from '@angular/core';
import {
  ServerConfigData,
  ServerConfigService,
} from '@ipg/ngx-frontend-toolset';
import { ConfirmHandler } from '../../../components/dialog/dialog.model';
import { DialogService } from '../../../components/dialog/dialog.service';
import { FileUploadDialogComponent } from '../components/file-upload-dialog/file-upload-dialog.component';
import {
  FileUploadDialogData,
  FileUploadDialogOptions,
  UploadFile,
} from '../models/file-upload.model';

@Injectable({
  providedIn: 'root',
})
export class FileUploadDialogService {
  private readonly _dialog = inject(DialogService);
  private readonly _serverConfig =
    inject<ServerConfigService<ServerConfigData>>(ServerConfigService);

  open(callback: ConfirmHandler<UploadFile[]>, options: FileUploadDialogOptions = {}) {
    const config = this._getAllowedConfig(options);

    return this._dialog.open<FileUploadDialogComponent, FileUploadDialogData>(
      FileUploadDialogComponent,
      {
        onConfirm: callback,
        allowedExtensions: config.map((c) => c.extension),
        allowedMimeTypes: config.map((c) => c.mimeType),
        maxSizeMap: new Map(config.map((c) => [c.mimeType, c.maxUploadSize])),
      },
      {
        maxWidth: '560px',
        width: '100%',
      }
    );
  }

  private _getAllowedConfig(options: FileUploadDialogOptions) {
    const fileConfig = this._serverConfig.data.fileAllowedTypes;

    return fileConfig
      .filter((value) =>
        options.allowedCategories
          ? options.allowedCategories.some((category) =>
              value.mimeType.startsWith(category)
            )
          : true
      )
      .filter((value) =>
        options.allowedExtensions
          ? options.allowedExtensions.includes(value.extension)
          : true
      );
  }
}
